import { Star } from 'lucide-react';

/**
 * Stjärnor med halva steg: 4,5 ska se ut som 4,5. Förut avrundades betyget
 * (Math.round(4,5) = 5), så Googles 4,5 visades som fem hela stjärnor bredvid
 * siffran 4,5. Ingen hook — fungerar i server- och klientkomponenter.
 */
export function Betygsstjarnor({
  betyg, storlek = 'h-5 w-5', fylld = 'fill-amber-400 text-amber-400', tom = 'text-muted-foreground/30', label,
}: { betyg: number; storlek?: string; fylld?: string; tom?: string; label?: string }) {
  return (
    <span className="inline-flex gap-0.5" role="img" aria-label={label ?? `${betyg} av 5 stjärnor`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const fyll = Math.max(0, Math.min(1, betyg - (n - 1)));
        const del = fyll >= 0.75 ? 100 : fyll >= 0.25 ? 50 : 0;
        return (
          <span key={n} className="relative inline-block" aria-hidden>
            <Star className={`${storlek} ${tom}`} />
            {del > 0 && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: `${del}%` }}>
                <Star className={`${storlek} ${fylld}`} />
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
}
